export type DocsProposalCadence = "ON_MERGE" | "DAILY" | "WEEKLY"

export const DOCS_PROPOSAL_CADENCE_LABEL = "Draft frequency"
export const DOCS_PROPOSAL_CADENCE_DESCRIPTION =
	"One set of drafts for everything that was released."

export const DOCS_PROPOSAL_CADENCE_OPTIONS: Array<{
	value: DocsProposalCadence
	label: string
}> = [
	{ value: "ON_MERGE", label: "After each merge" },
	{ value: "DAILY", label: "Daily" },
	{ value: "WEEKLY", label: "Weekly" },
]

export function docsDigestToggleTitle(
	cadence: DocsProposalCadence | undefined,
): string {
	return cadence === "WEEKLY"
		? "Weekly summary of docs drafts"
		: "Daily summary of docs drafts"
}

export function isDocsProposalCadence(
	value: string,
): value is DocsProposalCadence {
	return DOCS_PROPOSAL_CADENCE_OPTIONS.some((option) => option.value === value)
}
